import axios from "axios";

/**
 * Send QR scan notification to admin
 * Uses the new scan endpoint with built-in duplicate prevention
 */
const notify = async (stationId, ts) => {
    // Check sessionStorage to prevent duplicate sends for the same station in this tab/session
    const sessionKey = `qr_scan_sent:${stationId}`;
    
    if (sessionStorage.getItem(sessionKey)) {
        console.log('[QR Scan] Already sent notification for this station in this session, skipping');
        return { success: true, skipped: true };
    }
    
    try {
        // Use new scan endpoint
        const response = await axios.post(
            `${import.meta.env.VITE_API_URL}/stations/${encodeURIComponent(stationId)}/scan`,
            { source: 'qr' }
        );
        
        // Mark as sent in sessionStorage to prevent duplicates on page reload
        sessionStorage.setItem(sessionKey, Date.now().toString());
        
        console.log('[QR Scan] Notification sent successfully for station:', stationId);
        return response.data;
    } catch (error) {
        console.error('[QR Scan] Failed to send notification:', error);
        // Still mark as attempted to prevent spam on error
        sessionStorage.setItem(sessionKey, Date.now().toString());
        throw error;
    }
}

// A rating is submitted through POST /ev/sessions/:sessionUid/rating
// (sessionsApi), behind the session guard. The old POST /notify/rating helper
// had no caller and its endpoint now needs an operator or service credential.

export { notify };
